import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

const API = `${process.env.REACT_APP_API_BASE_URL}/property-finder/favourites`;

export const getFavourites = async () => {
  const response = await axios.get(`${API}`);

  return response?.data;
};

export const useFavourites = () =>
  useQuery({
    queryKey: ['propertyFinderFavourites'],
    queryFn: async () => {
      return await getFavourites();
    }
  });
